<template>
  <div>
    <v-container class="pt-8 px-10">
      <h1 class="display-1 mb-4">Comments</h1>
      <v-row class="px-4">
        <v-btn class="primary mb-4" @click="makeNewComment">
          <v-icon class="mr-1">mdi-plus</v-icon>New
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="primary mb-4 ml-4">
              <v-icon class="mr-1">mdi-sort</v-icon>Sort by
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(sortOpt, id) in sortOptions"
              :key="id" 
              :class="{ grey: sort === id, 'lighten-2': true }"
              @click="sort = id"
            >
              <v-list-item-title>
                {{ sortOpt.title }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
      <div class="comments mx-auto">
        <FbComment
          v-for="comment in sortedComments"
          class="mt-8"
          :key="comment.id"
          :comment="comment"
          @delete="confirmDeleteComment"
          @delete-reply="confirmDeleteReply" />
      </div>
    </v-container>

    <v-dialog v-model="deleteCommentDlg.show" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Comment</v-card-title>
        <v-card-text>
          Are you sure you want to delete this comment?
          <br><br>
          Tip: Hold <strong>Ctrl</strong> while clicking Delete to bypass confirmation
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteCommentDlg.show = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteComment">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteReplyDlg.show" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete Reply</v-card-title>
        <v-card-text>
          Are you sure you want to delete this reply?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteReplyDlg.show = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteReply">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FbComment from '../components/FbComment'

import { randomId, prefGet, prefSet } from '../utils'
import { randomSeed } from '../random-fb-profile'

const KEY_SORT = 'FbComments_sort'

export default {
  name: 'FbComments',
  injectModels: ['Store'],
  components: {
    FbComment
  },
  created() {
    window.addEventListener('mousemove', this.updatectrlKeyDown)

    this.statusId = this.$route.params.id
    this.sort = prefGet(KEY_SORT, this.sort)

    const status = this.getStatus()
    if (status)
      this.comments = status.comments || {}
  },
  destroyed() {
    window.removeEventListener('mousemove', this.updatectrlKeyDown)
  },
  data() {
    return {
      statusId: '',
      comments: {},
      sort: 'oldest',
      sortOptions: {
        oldest: { title: 'Oldest', key: 'timestamp', desc: false },
        mostRecent: { title: 'Most Recent', key: 'timestamp', desc: true },
        mostLiked: { title: 'Most Liked', key: 'likeCount', desc: true }
      },
      deleteCommentDlg: {
        show: false,
        id: ''
      },
      deleteReplyDlg: {
        show: false,
        commentId: '',
        replyId: ''
      },
      ctrlKeyDown: false
    }
  },
  computed: {
    sortedComments() {
      const comments = []
      for (let id in this.comments) {
        comments.push(this.comments[id])
      }
      return comments.sort((a, b) => {
        const { key, desc } = this.sortOptions[this.sort]
        const r = a[key] < b[key]
        return desc ? r : !r
      })
    }
  },
  methods: {
    getStatus() {
      return this.Store.fb.posts[this.statusId]
    },
    makeNewComment() {
      const status = this.getStatus()
      const id = randomId()

      const latestComment = Object.keys(this.comments)
        .map(id => this.comments[id])
        .sort((a, b) => a.timestamp < b.timestamp)[0] || {}
      const timestamp = latestComment.timestamp || status.timestamp

      const maleAuthor = Math.random() < 0.5
      const author = `@R:${randomSeed(maleAuthor)}`

      const newComments = { 
        ...status.comments,
        [id]: { id, timestamp, author }
      }

      status.comments = newComments
      this.comments = newComments
    },
    confirmDeleteComment(id) {
      this.deleteCommentDlg = { show: true, id }
      if (this.ctrlKeyDown)
        this.deleteComment()
    },
    deleteComment() {
      const status = this.getStatus()
      this.$delete(status.comments, this.deleteCommentDlg.id)
      this.deleteCommentDlg.show = false
    },
    confirmDeleteReply(commentId, replyId) {
      this.deleteReplyDlg = {
        show: true,
        commentId,
        replyId
      }
      if (this.ctrlKeyDown)
        this.deleteReply()
    },
    deleteReply() {
      const { commentId, replyId } = this.deleteReplyDlg
      this.$delete(this.getStatus().comments[commentId].replies, replyId)
      this.deleteReplyDlg.show = false
    },
    updatectrlKeyDown(ev) {
      this.ctrlKeyDown = ev.ctrlKey
    }
  },
  watch: {
    sort(value) {
      prefSet(KEY_SORT, value)
    }
  }
}
</script>

<style scoped>
.comments {
  max-width: 512px;
}

.comments > * {
  margin-bottom: 24px !important;
}
</style>